import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonIcon, IonSpinner, IonButton, IonModal, IonInput, IonMenuButton, IonRouterLink } from '@ionic/react';
import { IonSearchbar, IonFab, IonFabList, IonFabButton, IonList, IonItem, IonButtons, IonBackButton, IonAvatar, IonLabel } from '@ionic/react';
import './pump_customer.css';
import { people, add, cellularOutline, powerOutline, cloudOutline, settingsOutline } from 'ionicons/icons'
import axios, { AxiosResponse } from "axios";
import getApi from '../api';
import EnvironmentBadge from '../components/EnvironmentBadge';
import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router';
import { useLocalStorage } from '../components/useLocalStorage'
import { useIonViewWillEnter, useIonViewWillLeave } from '@ionic/react';
import { useHistory } from "react-router-dom";
import CountdownButton from '../components/CountdownButton';

const PumpCustomer: React.FC = () => {

  const { id } = useParams<{ id: string }>();
  let [Customer, setCustomer] = useLocalStorage("customer", "");
  let [Pumps, setPumps] = useState([]);
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [value, setValue] = useState<string | undefined>();
  const [p_id, setp_id] = useState<string | undefined>();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const increaseValue = () => setValue((prevValue) => ((parseFloat(prevValue || "0") + 0.1).toFixed(1)));
  const decreaseValue = () => setValue((prevValue) => ((parseFloat(prevValue || "0") - 0.1).toFixed(1)));


  const api = getApi();

  const [isLoading, setIsLoading] = useState(true);

  useIonViewWillEnter(() => {
    // Rensa listan och visa laddar-symbol innan vi hämtar nya data
    setPumps([]);
    setIsLoading(true);

    const fetchPumps = () => {
      api.get("/bbe/userpumps/?user=" + id)
        .then((res: AxiosResponse) => {
          setPumps(res.data.results);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    fetchPumps();
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(fetchPumps, 10000);
  }, [id, api]);


  useIonViewWillLeave(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  });

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  function sendCommand(command: string, pumpID: string) {
    console.log("Sending command: " + command + " to pump: " + pumpID);
    const data = new FormData();
    data.append('pID', pumpID);
    data.append('cID', command);
    api.post("/bbe/send/", data)
      .then((res: AxiosResponse) => {
        console.log(res);
      })
  }

  function show_b(b_value: number, p_id: string) {
    setp_id(p_id);
    setValue(((b_value / 10).toFixed(1) || "0.0"));
    setShowModal(true);
  }

  function sendBValue() {
    const data = new FormData();
    if (p_id) {
      data.append('pID', p_id.toString());
    }
    if (value) {
      console.log("Value: " + value);
      data.append('b_value', (parseFloat(value) * 10).toFixed(0));
    }
    data.append('cID', '6');
    api.post("/bbe/send/", data)
      .then((res: AxiosResponse) => {
        console.log(res);
        setShowModal(false);
      })
  }


  return (
    <>
      <IonPage placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonButtons slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonMenuButton placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
              <IonBackButton />
            </IonButtons>
            <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonTitle>
            <div slot="end" style={{ paddingRight: '8px' }}><EnvironmentBadge /></div>
          </IonToolbar>
        </IonHeader>

        <IonContent fullscreen placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              {isLoading && (
                <IonCol size="12" className="ion-text-center ion-padding" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonSpinner placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonSpinner>
                </IonCol>
              )}

              {!isLoading && Pumps.length === 0 && (
                <IonCol size="12" className="ion-text-center color-medium ion-padding" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <p>Denna kund har inga pumpar än.</p>
                </IonCol>
              )}

              {Pumps.map((result: any) => (
                <IonCol size="12" size-sm="3" key={result.id} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonCard id={result.id} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonGrid fixed={true} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCol size="8" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{result["name"]}</IonCardTitle></IonCol>
                            {result['online'] === true && result['type'] !== 'sms' && <IonCol class="ion-text-end" size="2" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonButton fill="clear" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonIcon color="success" icon={cloudOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                              </IonButton>
                            </IonCol>}
                            {result['online'] === false && result['type'] !== 'sms' && <IonCol class="ion-text-end" size="2" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonButton fill="clear" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonIcon color="danger" icon={cloudOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                              </IonButton>
                            </IonCol>}
                            {result['type'] !== 'sms' && <IonCol className="ion-text-end" size="2" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonButton fill="clear" onClick={() => history.push(`/pump/${id}/${result['id']}`)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonIcon color="secondary" icon={settingsOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                              </IonButton>
                            </IonCol>
                            }
                          </IonRow>
                        </IonGrid>
                      </IonCardHeader>
                      <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonCol class="status_name" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            Status:
                          </IonCol>
                          <IonCol class="status" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            {result['status']}
                          </IonCol>
                        </IonRow>

                        {result['type'] === 'mqtt' &&
                          <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCol class="status_name" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              Livedata:
                            </IonCol>
                            <IonCol class="status" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <CountdownButton pumpId={result['id']} token={window.localStorage.getItem("token") || ""} />
                            </IonCol>
                          </IonRow>
                        }

                        {result['type'] === 'sms' &&
                          <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonButton onClick={() => sendCommand("1", result['id'])} className="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonIcon slot="icon-only" icon={powerOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                              </IonButton>
                            </IonCol>
                            <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonButton onClick={() => sendCommand("2", result['id'])} className="stop" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonIcon slot="icon-only" icon={powerOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                              </IonButton>
                            </IonCol>
                          </IonRow>
                        }

                        {result['type'] === 'mqtt' &&
                          <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonButton onClick={() => sendCommand("4", result['id'])} className="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonIcon slot="icon-only" icon={powerOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                              </IonButton>
                            </IonCol>
                            <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonButton onClick={() => sendCommand("5", result['id'])} className="stop" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonIcon slot="icon-only" icon={powerOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                              </IonButton>
                            </IonCol>
                          </IonRow>
                        }

                        {result['type'] === 'mqih' &&
                          <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonButton onClick={() => {
                                const commands = result['pump']['commands'];
                                const startCommand = commands.find((command: { name: string; }) => command.name === 'Start');
                                const startCommandId = startCommand ? startCommand.id : null;
                                sendCommand(startCommandId, result['id']);
                              }} className="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonIcon slot="icon-only" icon={powerOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                              </IonButton>
                            </IonCol>
                            <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonButton onClick={() => {
                                const commands = result['pump']['commands'];
                                const startCommand = commands.find((command: { name: string; }) => command.name === 'Stopp');
                                const startCommandId = startCommand ? startCommand.id : null;
                                sendCommand(startCommandId, result['id']);
                              }} className="stop" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonIcon slot="icon-only" icon={powerOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                              </IonButton>
                            </IonCol>
                          </IonRow>
                        }

                        {result['type'] !== 'sms' && <><IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          {result['pump']['id'] != 6 && <>
                            <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonCard className="card-min" onClick={() => show_b(result['b_value'], result['id'])} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                  <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Valt Tryck</IonCardTitle>
                                </IonCardHeader>
                                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                  <IonLabel class="number" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{(((result['b_value'] as number) / 10).toFixed(1) || 0.00)}</IonLabel>
                                </IonCardContent>
                              </IonCard>
                            </IonCol>
                          </>}
                          {result['pump']['id'] != 6 && <>
                            <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonCard className="card-min" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                  <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Aktivt Tryck</IonCardTitle>
                                </IonCardHeader>
                                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                  <IonLabel class="number" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{(((result['r_value'] as number) / 10).toFixed(1) || 0.00)}</IonLabel>

                                </IonCardContent>
                              </IonCard>
                            </IonCol>
                          </>}
                        </IonRow><IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            {result['pump']['id'] != 6 && <>
                              <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonCard className="card-min" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                  <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                    <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Hz Motor</IonCardTitle>
                                  </IonCardHeader>
                                  <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                    <IonLabel class="number" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{((result['hz_value'] as number) || 0)}</IonLabel>

                                  </IonCardContent>
                                </IonCard>
                              </IonCol>
                            </>}
                            <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonCard className="card-min" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonCardHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                  <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Flöde</IonCardTitle>
                                </IonCardHeader>
                                <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                  <IonLabel class="number" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{((result['flow_minute'] as number) || 0)}</IonLabel>

                                </IonCardContent>
                              </IonCard>
                            </IonCol>
                          </IonRow></>}
                      </IonGrid>
                    </IonCardContent>
                  </IonCard>
                </IonCol>

              ))}
            </IonRow>
          </IonGrid>

          <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)} initialBreakpoint={0.25} breakpoints={[0, 0.25, 0.5, 0.75]} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonButton className="set_bor_button" onClick={increaseValue} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>+</IonButton></IonCol>
                <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonInput class="set_bor" value={value} readonly placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></IonCol>
                <IonCol class="center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonButton className="set_bor_button" onClick={decreaseValue} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>-</IonButton></IonCol>
              </IonRow>
              <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonButton className="save_button" expand="block" onClick={() => sendBValue()} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Spara</IonButton>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonModal>
        </IonContent>
      </IonPage></>
  );
};

export default PumpCustomer;
